export const SEGA_HARDWARE = [
    {
  id: "dreamcast",
  name: "SEGA Dreamcast",
  brand: "SEGA",
  type: "console",
  category: "SEGA",
  variants: [
    {
      id: "dreamcast-standard",
      name: "Dreamcast",
      versions: [
        {
          id: "dreamcast",
          name: "SEGA Dreamcast",
          storage: "",
          disc: true,
          image: "/images/consoles/dreamcast.png",
        },
      ],
    },
  ],
},

{
  id: "saturn",
  name: "SEGA Saturn",
  brand: "SEGA",
  type: "console",
  category: "SEGA",
  variants: [
    {
      id: "saturn-standard",
      name: "Saturn",
      versions: [
        {
          id: "saturn",
          name: "SEGA Saturn",
          storage: "",
          disc: true,
          image: "/images/consoles/saturn.png",
        },
      ],
    },
  ],
},

{
  id: "mega-drive",
  name: "SEGA Mega Drive",
  brand: "SEGA",
  type: "console",
  category: "SEGA",
  variants: [
    {
      id: "mega-drive-models",
      name: "Mega Drive",
      versions: [
        {
          id: "mega-drive-1",
          name: "Mega Drive",
          storage: "",
          disc: false,
          image: "/images/consoles/mega-drive.png",
        },
        {
          id: "mega-drive-2",
          name: "Mega Drive II",
          storage: "",
          disc: false,
          image: "/images/consoles/mega-drive-2.png",
        },
        {
          id: "mega-drive-mini",
          name: "Mega Drive Mini",
          storage: "",
          disc: false,
          mini: true,
          image: "/images/consoles/mega-drive-mini.png",
        },
        {
          id: "mega-drive-mini-2",
          name: "Mega Drive Mini 2",
          storage: "",
          disc: false,
          mini: true,
          image: "/images/consoles/mega-drive-mini-2.png",
        },
      ],
    },
  ],
},

{
  id: "master-system",
  name: "SEGA Master System",
  brand: "SEGA",
  type: "console",
  category: "SEGA",
  variants: [
    {
      id: "master-system-models",
      name: "Master System",
      versions: [
        {
          id: "master-system-1",
          name: "Master System",
          storage: "",
          disc: false,
          image: "/images/consoles/master-system.png",
        },
        {
          id: "master-system-2",
          name: "Master System II",
          storage: "",
          disc: false,
          image: "/images/consoles/master-system-2.png",
        },
      ],
    },
  ],
},

{
  id: "game-gear",
  name: "SEGA Game Gear",
  brand: "SEGA",
  type: "console",
  category: "SEGA",
  variants: [
    {
      id: "game-gear-standard",
      name: "Game Gear",
      versions: [
        {
          id: "game-gear",
          name: "SEGA Game Gear",
          storage: "",
          disc: false,
          image: "/images/consoles/game-gear.png",
        },
      ],
    },
  ],
},
]